export default { id: 'none', name: 'None' };
